module.exports = __webpack_public_path__ + "img/w11b.2682faf9.jpg";